<template>
  <v-container>
    <!-- Borra  -->
    <v-simple-table v-if="borra.id" class="mt-12">
      <thead>
        <h1>Vista detallada de stock de borra</h1>
      </thead>
      <tbody>
        <tr>
          <td>
            <b>Barcode</b>
          </td>
          <td>{{ borra.barcode }}</td>
        </tr>
        <tr>
          <td>
            <b>Fàbrica</b>
          </td>
          <td>{{ textFabrica(borra.fabrica) }}</td>
        </tr>
        <tr>
          <td>
            <b>Fabricada en quarto</b>
          </td>
          <td>{{ borra.cuarto }}</td>
        </tr>
        <tr>
          <td>
            <b>Magatzem</b>
          </td>
          <td>{{ borra.magatzem_nom }}</td>
        </tr>
        <tr>
          <td>
            <b>Partida</b>
          </td>
          <td>{{ borra.partida }}</td>
        </tr>
        <tr>
          <td>
            <b>Cost quilo</b>
          </td>
          <td>{{ borra.cost_quilo }} €/kg</td>
        </tr>
        <tr>
          <td>
            <b>Preu quilo (€/kg)</b>

          </td>
          <td>{{ parseFloat(borra.preu_quilo).toFixed(3) }} €/kg</td>
        </tr>
        <tr>
          <td>
            <b>Quilos</b>
          </td>
          <td>{{ borra.quilos }} kg</td>
        </tr>
        <tr>
          <td>
            <b>Reservada</b>
          </td>
          <td>{{ borra.reservada ? 'Sí' : 'No' }}</td>
        </tr>
        <tr>
          <td>
            <b>Tipus de borra</b>
          </td>
          <td>{{ borra.tipus_borra_nom }}</td>
        </tr>
        <tr v-if="borra.observacions">
          <td>
            <b>Observacions</b>
          </td>
          <td>{{ borra.observacions }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <!-- Botons d'opcions -->
    <div id="botonera">
      <v-btn color="success" dark @click="redireccio('StockBorraList')">Tornar al llistat</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="btnImprimirPegatina">Imprimir etiqueta</v-btn>
    </div>
    <!-- Botons d'opcions -->
    <v-dialog v-model="dialogPegatina" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Etiqueta impresa</v-card-title>
          <v-card-text>Esta etiqueta està impresa</v-card-text>
          <v-card-text>Confirme que vol imprimir-la de nou.</v-card-text>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialogPegatina = false">Cancel·lar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="imprimirPegatina">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!-- Footer -->
    <v-footer class="font-weight-medium" height="38%">
      <v-col v-if="$route.params.sense" class="text-center" cols="12" @click="
      $router.push({ name: 'StockBorraMagatzemBorraList', params: { magatzemID: 'Sense'} });" style="padding:0px">
        <span>Gestió Integral Borreres, {{ new Date().getFullYear() }}</span>
      </v-col>
      <v-col v-else class="text-center" cols="12" @click="redireccio('StockBorraList')" style="padding:0px">
        <span>Gestió Integral Borreres, {{ new Date().getFullYear() }}</span>
      </v-col>
    </v-footer>
    <!-- ./Footer -->
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";


export default {
  name: "stock-borra-detail",
  data: () => ({
    borra: {
      quilos: null,
      preu_quilo: null,
      reservada: false,
      observacions: "",
      fabricada_en_cuarto: null,
      tipus_borra: null,
      fabrica: null,
      magatzem: null,
      partida: null
    }, 
    dialogPegatina: false
  }),
  computed: {
    ...mapGetters({
      fabriques: "getFabriques"
    })
  },
  methods: {
    ...mapActions([
      "editMateriaProducteFinal",
      "eliminarMateriaProducteFinal",
      "getBorra",
      "getFabriques",
      "getMagatzem",
      "getMagatzemNumero",
      "getMateriaProducteFinal",
      "getOrdreEixida", 
      "getPartida",
      "getQuartoMesclat",
      "imprimirPegatinaBalaBorra_new"
    ]),

    // Auxiliars
    btnImprimirPegatina(){
      if(this.borra.impresa){
        this.dialogPegatina = true;
      } else {
        this.imprimirPegatina();
      }
    },
    imprimirPegatina(){


      this.imprimirPegatinaBalaBorra_new({id: this.borra.id, info_impresion:{destino:"FrontEnd", 
      request_id: localStorage.getItem('uuid')}})
    },
    redireccio(component) {
      this.$router.push({ name: component,
        params: {
          magatzemID: this.borra.posicion_almacenamiento,
          BorraID: this.borra.tipus_borra
        }});
    },
    textFabrica(fabricaID) {
      return this.fabriques.find(el => el.id === fabricaID)?.nom;
    },
    textPartida(partidaID) {
      return this.partides.find(el => el.id === partidaID)?.nom;
    },
    textOrdreEixida(ordreEixidaID) {
      const data = this.ordresEixida
        .find(el => el.id === ordreEixidaID)
        ?.data_hora.split("T")[0].replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');
      return `${ordreEixidaID} - ${data}`;
    },
    textTipusBorra(tipusBorraID) {
      return this.tipusBorra.find(el => el.id === tipusBorraID)?.nom;
    },
    textQuarto(id){
      if(id){
        this.getQuartoMesclat(id).then(quartoInfo=>{
          this.borra.cuarto = quartoInfo.quarto
        })
      }
    },
  },
  async created() {
    this.getFabriques();
    await this.getBorra(this.$route.params.id).then(
      borra => {(this.borra = borra)
          if (this.borra.magatzem) {
          this.getMagatzemNumero(parseInt(this.borra.posicion_almacenamiento.substr(1, 3))).then(magatzemInfo => {
            this.borra.magatzem = magatzemInfo[0]?.nom;
            if(parseInt(this.borra.posicion_almacenamiento.substr(4, 2))>0){
              this.borra.magatzem_nom = magatzemInfo[0]?.nom + ' - Nº '+ this.borra.posicion_almacenamiento.substr(4, 2)
            }
          });
        }
        //this.getMagatzem(this.borra.magatzem).then(magatzem => {
        //this.borra.magatzem_nom = magatzem?.nom;
        //});
        this.getPartida(this.borra.partida).then(partida => {
          this.borra.partida = partida?.codi.replaceAll('.', '');
          this.borra.cost_quilo = (partida.cost_materies_primeres/partida.quilos_borra_totales).toFixed(2)

        });
        this.getMateriaProducteFinal(this.borra.tipus_borra).then(tipusBorra => {
          this.borra.tipus_borra_nom = tipusBorra?.nom;
        });
        this.textQuarto(this.borra.cuarto);
      }
    );
  }
};
</script>

<style lang="scss" scoped>
// Taules
table {
  thead {
    h1 {
      text-align: center;
      padding-bottom: 1em;
    }
  }
  tbody {
    tr {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      td {
        width: 40%;
      }
    }
  }
}
#botonera {
  padding-bottom: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  button {
    width: 40%;
  }
}
</style>